import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "App-Opp" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { "mute-secondary": "" }
const _hoisted_4 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpportunityHeader = _resolveComponent("OpportunityHeader")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_OpportunityUpdateModal = _resolveComponent("OpportunityUpdateModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OpportunityHeader, { opportunity: _ctx.opportunity }, null, 8, ["opportunity"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", {
          "as-pointer": "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToOpportunity && _ctx.goToOpportunity(...args)))
        }, _toDisplayString(_ctx.opportunity.talents) + " " + _toDisplayString(_ctx.opportunity.skill[1]) + " " + _toDisplayString(_ctx.$filters.capitalize(_ctx.decideTalentWording())) + " Needed to " + _toDisplayString(_ctx.opportunity.outcome), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_app_truncate, {
          content: _ctx.opportunity.description,
          max: _ctx.max,
          onViewMore: _ctx.clickedMore,
          "m-tb-0": ""
        }, null, 8, ["content", "max", "onViewMore"])
      ]),
      _createVNode(_component_el_space, {
        size: 10,
        wrap: ""
      }, {
        default: _withCtx(() => [
          (_ctx.opportunity.compensation)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "Way of compensation"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    "tag-default": "",
                    "is-all-borderless": "",
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.compensation.join(", "))), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tooltip, { content: "Way of working, can be Remote, Physical, or Both." }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                "tag-default": "",
                "is-all-borderless": "",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.wow)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (
            (_ctx.opportunity.wow == 'hybrid' || _ctx.opportunity.wow == 'physical') &&
            _ctx.opportunity.location !== undefined
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("i", {
                  primary: "",
                  class: "el-icon-location",
                  style: {"margin-right":"2px"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.opportunity.location.description), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" From ", -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$moment(_ctx.opportunity.startDate).format("D MMM yy")), 1)
          ]),
          _createElementVNode("span", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" To ", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$moment(_ctx.opportunity.endDate).format("D MMM yy")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider, { style: {"margin-bottom":"8px"} }),
    _createVNode(_component_el_row, {
      align: "center",
      justify: "space-between",
      "w-100": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_el_link, {
            onClick: _ctx.goToOpportunity,
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Read More ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, !_ctx.isAtMax]
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.isOwner)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _ctx.updateOpportunity,
                "is-all-borderless": "",
                icon: "el-icon-edit",
                size: "small",
                round: ""
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Edit", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.isOwner)
      ? (_openBlock(), _createBlock(_component_OpportunityUpdateModal, {
          key: 0,
          onClosed: _ctx.stopUpdateOpportunity,
          opportunity: _ctx.opportunity,
          isModalOpen: _ctx.isEditing
        }, null, 8, ["onClosed", "opportunity", "isModalOpen"]))
      : _createCommentVNode("", true)
  ]))
}